export default __webpack_public_path__ + "static/media/sound_on.f11904bc.svg";